import { ReactNode } from 'react';
import clsx from 'clsx';

interface CardProps {
  children: ReactNode;
  className?: string;
  withBorder?: boolean;
  leftAccent?: string;
}

export const Card = ({ children, className, withBorder, leftAccent }: CardProps) => {
  return (
    <div
      className={clsx(
        'rounded-card bg-white p-6',
        {
          'border border-gray-300': withBorder,
          'shadow-sm': !withBorder,
          'relative overflow-hidden pl-8': leftAccent,
        },
        className
      )}
    >
      {leftAccent && (
        <div
          className="absolute bottom-0 left-0 top-0 w-2.5"
          style={{ backgroundColor: leftAccent }}
        />
      )}
      {children}
    </div>
  );
};
